import { AuthenticationTokenExpiry } from './_submodels/authentication-token-expiry.mode';

export class AuthenticationDetails {
  public authenticated: boolean;
  public emailVerified: boolean;
  public userId: string;
  public roles: string[] = [];
  public token: string;
  public expiry: AuthenticationTokenExpiry;
}
